module.exports = __webpack_public_path__ + "img/base.4736edc2.png";